import { pageSectionFields, pageSectionTypes } from "./storefront-sections.js";
/** অ্যাডমিনে অনলাইন স্টোর (docs/specs/storefront.md, ফেজ ৪)। */
export const storefront = {
    title: "অনলাইন স্টোর",
    description: "ওয়েবে আপনার নিজের দোকান, ব্রাঞ্চ ও POS-এর একই স্টক থেকে বিক্রি।",
    status: {
        live: "চালু",
        off: "বন্ধ",
        notInPlan: "আপনার প্ল্যানে নেই",
    },
    shopAddress: "দোকানের ঠিকানা",
    openShop: "দোকান খুলুন",
    copyAddress: "ঠিকানা কপি করুন",
    copied: "ঠিকানা কপি হয়েছে।",
    notInPlan: "আপনার প্ল্যানে অনলাইন স্টোর নেই। চালু করতে প্ল্যান আপগ্রেড করুন।",
    enable: "অনলাইন স্টোর চালু করুন",
    enableHint: "চালু থাকলে ক্রেতারা দোকানে ঢুকে অর্ডার করতে পারবেন।",
    stockTitle: "অনলাইন অর্ডারের স্টক",
    stockHint: "অনলাইন অর্ডারের স্টক এই ব্রাঞ্চগুলো থেকে কাটা হবে। কোনোটি না বাছলে: অনলাইন অর্ডারের ডিফল্ট লোকেশন।",
    noLocations: "এখনো কোনো চালু লোকেশন নেই।",
    defaultLocation: "অনলাইন অর্ডারের ডিফল্ট লোকেশন",
    showStockCount: "কয়টি বাকি আছে দেখান",
    showStockCountHint: "বন্ধ থাকলে ক্রেতারা শুধু স্টকে আছে, অল্প বাকি বা স্টক শেষ দেখবেন।",
    showSoldCount: "কতগুলো বিক্রি হয়েছে দেখান",
    showSoldCountHint: "পণ্যে “গত ৩০ দিনে ১০+ বিক্রি” (বা ৫০+, ১০০+) দেখায়, শুধু ডেলিভারি হওয়া অর্ডার থেকে গোনা। ১০-এর কম হলে কিছুই দেখায় না।",
    hidePoweredBy: "“Powered by Sobthik” লুকান",
    hidePoweredByHint: "শপের ফুটারে শুধু আপনার নিজের নাম দেখাবে।",
    paymentTitle: "পেমেন্ট",
    codEnabled: "ক্যাশ অন ডেলিভারি",
    codEnabledHint: "ক্রেতারা ডেলিভারির সময় টাকা দিতে পারবেন।",
    checkoutOtp: "অর্ডারের আগে SMS কোড চাওয়া হবে",
    checkoutOtpHint: "ক্রেতা SMS-এ পাওয়া কোড দিয়ে ফোন নম্বর নিশ্চিত করবেন। বন্ধ থাকলে শুধু ফোন নম্বর দিয়েই অর্ডার হবে; তখন ক্যাশ অন ডেলিভারি অর্ডার Received অবস্থায় আসবে এবং আপনি ফোন করে নিশ্চিত না করা পর্যন্ত স্টক আটকাবে না।",
    contactTitle: "দোকানে দেখানো যোগাযোগ",
    contactPhone: "ফোন",
    contactPhoneHint: "খালি থাকলে: ব্যবসার সেটিংসের ফোন নম্বর।",
    contactEmail: "ই-মেইল",
    saved: "অনলাইন স্টোরের সেটিংস সেভ হয়েছে।",
    conflict: "অন্য কেউ এই সেটিংস পরিবর্তন করেছেন। আবার লোড করা হয়েছে।",
    domains: {
        title: "আপনার নিজের ডোমেইন",
        description: "নিজের ঠিকানা ব্যবহার করুন, যেমন shop.yourname.com। এর DNS সেটিংসে আপনার অ্যাক্সেস লাগবে।",
        notInPlan: "আপনার প্ল্যানে নিজস্ব ডোমেইন নেই। যুক্ত করতে প্ল্যান আপগ্রেড করুন।",
        add: "ডোমেইন যুক্ত করুন",
        hostname: "ডোমেইন",
        hostnamePlaceholder: "shop.example.com",
        apexHint: "www.example.com বা shop.example.com এর মতো নাম দিন; শুধু example.com তখনই কাজ করবে যদি আপনার DNS প্রোভাইডার CNAME flattening সমর্থন করে।",
        empty: "এখনো নিজস্ব ডোমেইন নেই। ক্রেতারা উপরের দোকানের ঠিকানা ব্যবহার করছেন।",
        platformAddress: "প্ল্যাটফর্ম ঠিকানা: {{host}}",
        status: {
            pending_dns: "DNS-এর অপেক্ষায়",
            verifying: "যাচাই হচ্ছে",
            active: "চালু",
            failed: "কাজ করছে না",
            blocked: "ব্লক করা",
        },
        primary: "মূল ঠিকানা",
        makePrimary: "মূল ঠিকানা করুন",
        clearPrimary: "প্ল্যাটফর্ম ঠিকানাকে মূল করুন",
        check: "আবার যাচাই করুন",
        remove: "সরিয়ে দিন",
        removeTitle: "{{host}} সরিয়ে দেবেন?",
        removeBody: "এই ডোমেইনে দোকানটি আর খুলবে না। পরে আবার যুক্ত করতে পারবেন।",
        recordsTitle: "আপনার DNS প্রোভাইডারে এই রেকর্ডগুলো যোগ করুন",
        recordType: "ধরন",
        recordName: "নাম",
        recordValue: "মান",
        recordsHint: "DNS পরিবর্তনে কয়েক মিনিট থেকে কয়েক ঘণ্টা লাগতে পারে। আমরা ৭২ ঘণ্টা ধরে নিজে থেকে যাচাই করি।",
        lastChecked: "শেষ যাচাই {{when}}",
        added: "ডোমেইন যুক্ত হয়েছে। এখন নিচের DNS রেকর্ডগুলো যোগ করুন।",
        checking: "ডোমেইন যাচাই হচ্ছে…",
        primarySet: "{{host}} এখন মূল ঠিকানা।",
        primaryCleared: "প্ল্যাটফর্ম ঠিকানা আবার মূল ঠিকানা।",
        removed: "ডোমেইন সরানো হয়েছে।",
    },
    product: {
        title: "অনলাইন স্টোর",
        description: "এই পণ্যটি আপনার অনলাইন দোকানে দেখান।",
        published: "অনলাইন স্টোরে দেখান",
        publishedHint: "ক্রেতারা এটি অনলাইনে খুঁজে কিনতে পারবেন।",
        archived: "আর্কাইভ করা পণ্য অনলাইনে দেখানো হয় না।",
        slug: "ওয়েব ঠিকানা",
        slugHint: "অক্ষর, সংখ্যা ও ড্যাশ। পরিবর্তন করলেও পুরনো ঠিকানা কাজ করবে।",
        seoTitle: "সার্চ শিরোনাম",
        seoTitleHint: "সর্বোচ্চ ৭০ অক্ষর। খালি থাকলে: পণ্যের নাম।",
        seoDescription: "সার্চ বিবরণ",
        seoDescriptionHint: "সর্বোচ্চ ১৭০ অক্ষর। খালি থাকলে: বিবরণের শুরু।",
        count: "{{count}}/{{max}}",
        saved: "পণ্যের অনলাইন স্টোর সেটিংস সেভ হয়েছে।",
    },
    extras: {
        title: "পণ্যের পাতার বিবরণ",
        description: "অনলাইন শপে এই পণ্যের সাথে দেখানোর স্পেসিফিকেশন, সাইজ চার্ট ও অন্যান্য পণ্য।",
        specs: "স্পেসিফিকেশন",
        specsHint: "ক্রেতারা যা তুলনা করেন: কাপড়, ব্যাটারি, উপাদান, মাপ…",
        group: "গ্রুপের নাম",
        label: "নাম",
        value: "মান",
        addRow: "লাইন যোগ করুন",
        removeRow: "এই লাইনটি সরান",
        addGroup: "গ্রুপ যোগ করুন",
        removeGroup: "এই গ্রুপটি সরান",
        sizeGuide: "সাইজ চার্ট",
        hasSizeGuide: "পণ্যের পাতায় সাইজ চার্ট দেখান",
        unit: "একক",
        units: { inch: "ইঞ্চি", cm: "সেন্টিমিটার", none: "একক নেই" },
        column: "কলাম {{n}}",
        cell: "সারি {{row}}, {{column}}",
        addSizeRow: "সাইজ যোগ করুন",
        addColumn: "কলাম যোগ করুন",
        removeLastRow: "শেষ সাইজ সরান",
        removeLastColumn: "শেষ কলাম সরান",
        howToMeasure: "কীভাবে মাপবেন",
        picks: "এর সাথে মানানসই",
        picksHint: "এই পণ্যের সাথে সর্বোচ্চ ৮টি পণ্য, এই ক্রমে দেখানো হবে (\u201cপুরো লুক\u201d, বান্ডেল)।",
        findProduct: "যোগ করতে পণ্য খুঁজুন",
        removePick: "{{name}} সরান",
        saved: "পণ্যের পাতার বিবরণ সংরক্ষিত হয়েছে।",
    },
    bulk: {
        selected: "{{count}}টি বাছাই করা",
        publish: "অনলাইনে দেখান",
        unpublish: "অনলাইনে লুকান",
        done: "{{count}}টি পণ্য পরিবর্তন হয়েছে।",
        skipped: "আর্কাইভ করা {{count}}টি পণ্য বাদ গেছে।",
    },
    gateways: {
        title: "অনলাইন পেমেন্ট",
        description: "ক্রেতারা আপনার নিজের bKash, Nagad বা SSLCommerz মার্চেন্ট অ্যাকাউন্টে টাকা দিতে পারবেন। টাকা সরাসরি আপনার কাছে যাবে।",
        names: { bkash: "bKash", nagad: "Nagad", sslcommerz: "SSLCommerz (কার্ড ও ওয়ালেট)" },
        enabled: "{{name}} দিয়ে পেমেন্ট নিন",
        sandbox: "টেস্ট মোড (গেটওয়ের স্যান্ডবক্স)",
        account: "টাকা জমা হবে",
        chooseAccount: "পেমেন্ট অ্যাকাউন্ট বাছুন",
        configured: "ক্রেডেনশিয়াল সেভ করা আছে",
        notConfigured: "এখনো ক্রেডেনশিয়াল নেই",
        replace: "নতুন ক্রেডেনশিয়াল দিন",
        fields: {
            storeId: "স্টোর আইডি",
            storePassword: "স্টোর পাসওয়ার্ড",
            appKey: "অ্যাপ কী",
            appSecret: "অ্যাপ সিক্রেট",
            username: "ইউজারনেম",
            password: "পাসওয়ার্ড",
            merchantId: "মার্চেন্ট আইডি",
            merchantPrivateKey: "মার্চেন্ট প্রাইভেট কী",
            nagadPublicKey: "Nagad পাবলিক কী",
        },
        secretHint: "এনক্রিপ্ট করে রাখা হয়। আর কখনো দেখানো হবে না।",
        saved: "{{name}} সেটিংস সেভ হয়েছে।",
    },
    coupons: {
        title: "কুপন",
        description: "আপনার অনলাইন স্টোরের ডিসকাউন্ট কোড ও স্বয়ংক্রিয় অফার।",
        new: "নতুন কুপন",
        edit: "{{code}} সম্পাদনা",
        empty: "এখনো কোনো কুপন নেই।",
        code: "কোড",
        kind: "ধরন",
        kinds: { percent: "শতাংশ ছাড়", amount: "টাকা ছাড়", free_delivery: "ফ্রি ডেলিভারি" },
        percent: "শতাংশ",
        amount: "টাকা (৳)",
        maxDiscount: "সর্বোচ্চ (৳, ঐচ্ছিক)",
        minOrder: "সর্বনিম্ন অর্ডার (৳)",
        startsAt: "শুরু (ঐচ্ছিক)",
        endsAt: "শেষ (ঐচ্ছিক)",
        limitTotal: "মোট ব্যবহার (ঐচ্ছিক)",
        limitPerPhone: "প্রতি ফোনে ব্যবহার (ঐচ্ছিক)",
        autoApply: "অর্ডার শর্ত পূরণ করলে নিজে থেকে প্রয়োগ হবে",
        paused: "বন্ধ",
        active: "চালু",
        used: "ব্যবহার",
        value: "মান",
        saved: "কুপন {{code}} সেভ হয়েছে।",
        unlimited: "সীমা নেই",
    },
    reviews: {
        title: "রিভিউ",
        description: "ক্রেতারা কী বলছেন। নতুন ৪–৫ স্টার রিভিউ সাথে সাথে দেখা যায়, নিচে বদলাতে পারেন।",
        autoPublish: "নতুন রিভিউ প্রকাশ",
        modes: {
            none: "আমি দেখার পরেই",
            good: "৪ ও ৫ স্টার সাথে সাথে, বাকিগুলো দেখার পরে",
            all: "সবগুলো সাথে সাথে",
        },
        empty: "দেখানোর মতো কোনো রিভিউ নেই।",
        pending: "অপেক্ষায়",
        published: "চালু",
        hidden: "লুকানো",
        publish: "প্রকাশ করুন",
        hide: "লুকান",
        reply: "উত্তর (ঐচ্ছিক)",
        saved: "রিভিউ আপডেট হয়েছে।",
        filters: { all: "সব", pending: "অপেক্ষায়", published: "চালু", hidden: "লুকানো" },
    },
    appearance: {
        title: "চেহারা",
        description: "আপনার অনলাইন দোকানের রং, মেনু ও লেখা। প্রকাশ না করা পর্যন্ত পরিবর্তনগুলো খসড়ায় থাকে।",
        open: "চেহারা বদলান",
        colors: "রং",
        primary: "মূল রং (বাটন, লিংক)",
        accent: "সহায়ক রং",
        shape: "কোণ",
        radii: { none: "চৌকো", small: "সামান্য গোল", medium: "গোল", large: "বেশি গোল" },
        headingFont: "শিরোনামের ফন্ট",
        fonts: { inter: "পরিষ্কার (Inter)", serif: "ক্লাসিক (serif)", rounded: "বন্ধুসুলভ (rounded)" },
        announcement: "ঘোষণা বার",
        announcementOn: "ঘোষণা বার দেখান",
        announcementText: "লেখা",
        link: "লিংক (ঐচ্ছিক)",
        headerMenu: "হেডার মেনু",
        footerMenu: "ফুটার মেনু",
        menuHint: "হেডার মেনু খালি থাকলে আপনার ক্যাটাগরিগুলো দেখানো হবে।",
        addLink: "লিংক যোগ করুন",
        label: "নাম",
        href: "লিংক (/products বা https://…)",
        remove: "সরান",
        social: "সোশ্যাল লিংক",
        policies: "নীতিমালার পেজ",
        policyHint: "সাধারণ লেখা; অনুচ্ছেদের মাঝে একটি ফাঁকা লাইন রাখুন। খালি পেজ দেখানো হয় না।",
        saveDraft: "খসড়া সেভ করুন",
        preview: "প্রিভিউ",
        publish: "প্রকাশ করুন",
        draftSaved: "খসড়া সেভ হয়েছে।",
        published: "আপনার দোকানে এখন নতুন চেহারা দেখা যাচ্ছে।",
        lastPublished: "{{when}} থেকে চালু",
        neverPublished: "এখনো প্রকাশ হয়নি — দোকানে ডিফল্ট চেহারা দেখাচ্ছে।",
        style: "থিমের স্টাইল",
        styleHint: "শুধু আপনার থিমে যা আছে। যেকোনো পছন্দে লেখা পড়া সহজ থাকে, পেজ দ্রুত থাকে।",
        baseTheme: "থিম: {{name}}",
        changeTheme: "থিম বদলান",
        palette: "রঙের সেট",
        customPalette: "নিজের রঙ",
        contrast: "কনট্রাস্ট {{ratio}}:১",
        contrastGood: "সহজে পড়া যায়",
        contrastSample: "অআ",
        contrastLow: "সাদা লেখার জন্য খুব হালকা — আরও গাঢ় প্রধান রঙ বেছে নিন",
        fontPairing: "ফন্ট",
        fontPairings: { signature: "থিমের ফন্ট", classic: "ক্লাসিক (সবচেয়ে দ্রুত)" },
        fontSample: "Aa অআ ক্ষ",
        layout: "লেআউট ও আচরণ",
        optionNames: {
            headerStyle: "হেডার",
            cardStyle: "পণ্যের কার্ড",
            buttonStyle: "বোতাম",
            colorScheme: "হালকা না গাঢ়",
            density: "ফাঁকা জায়গা",
            motion: "অ্যানিমেশন",
            stickyBuyBar: "পণ্যের পেজে কেনার বার (ফোনে)",
            quickAdd: "কার্ড থেকেই দ্রুত যোগ",
            showSecondImage: "মাউস রাখলে দ্বিতীয় ছবি",
            bottomNav: "নিচের ট্যাব বার (ফোনে)",
            cartOpens: "কার্টে যোগ করার পর",
            announcementStyle: "ঘোষণার বার্তা",
            headerScroll: "স্ক্রল করার সময় হেডার",
        },
        optionValues: {
            classic: "ক্লাসিক",
            centered: "মাঝখানে",
            split: "দুই ভাগ",
            minimal: "সাধারণ",
            search_first: "আগে সার্চ",
            standard: "সাধারণ",
            overlay: "ছবির উপর লেখা",
            bordered: "বর্ডারসহ",
            list: "তালিকা",
            solid: "ভরাট",
            outline: "আউটলাইন",
            pill: "গোল",
            sharp: "চারকোনা",
            light: "হালকা",
            dark: "গাঢ়",
            compact: "ঘন",
            comfortable: "আরামদায়ক",
            airy: "খোলামেলা",
            full: "পুরো",
            subtle: "হালকা",
            off: "বন্ধ",
            on: "চালু",
            drawer: "কার্ট খুলবে",
            toast: "ছোট বার্তা দেখাবে",
            static: "একটি করে",
            rotating: "পালা করে",
            marquee: "চলমান লাইন",
            sticky: "সবসময় দেখা যাবে",
            hide_on_scroll: "নিচে স্ক্রল করলে লুকাবে",
        },
        moreMessages: "আরও বার্তা (পালা করে দেখাবে)",
        addMessage: "বার্তা যোগ করুন",
        trending: "জনপ্রিয় সার্চ",
        trendingHint: "ক্রেতা লেখার আগেই সার্চ বক্সে দেখাবে, সর্বোচ্চ ৮টি।",
        addSearch: "সার্চ যোগ করুন",
        chat: "চ্যাট বোতাম",
        chatHint: "প্রতিটি পেজের কোণে একটি বোতাম। আগে উপরে নম্বর বা পেজ দিন।",
        chatOptions: { off: "বন্ধ", whatsapp: "হোয়াটসঅ্যাপ", messenger: "মেসেঞ্জার" },
        trust: "ভরসার ব্যাজ",
        trustHint: "যে প্রতিশ্রুতি আপনি রাখেন, পণ্যের পেজে দেখাবে (সর্বোচ্চ ৪টি), যেমন “অরিজিনাল পণ্য”।",
        addBadge: "ব্যাজ যোগ করুন",
        previewTitle: "লাইভ প্রিভিউ",
        previewHint: "আপনার সেভ করা ড্রাফট দেখায়। ক্রেতারা এখনো প্রকাশিত চেহারাই দেখছেন।",
        updatePreview: "সেভ করে প্রিভিউ দেখুন",
        unsaved: "কিছু পরিবর্তন এখনো প্রিভিউতে দেখাচ্ছে না।",
        openPreview: "নতুন ট্যাবে খুলুন",
        devices: { phone: "ফোন", tablet: "ট্যাবলেট", desktop: "ডেস্কটপ" },
        previewFrame: "{{device}}-এ আপনার দোকানের প্রিভিউ",
    },
    takenDown: "প্ল্যাটফর্ম আপনার অনলাইন স্টোর বন্ধ করেছে। আবার খুলতে সাপোর্টে যোগাযোগ করুন।",
    pages: {
        title: "পেজ",
        description: "আপনার হোম পেজ, বাড়তি পেজ আর বিজ্ঞাপনের জন্য এক-পণ্যের ল্যান্ডিং পেজ।",
        new: "নতুন পেজ",
        empty: "এখনো কোনো পেজ নেই। হোম পেজ দিয়ে শুরু করুন।",
        fromHome: "হোম পেজের লেআউট থেকে শুরু করুন",
        fromHomeHint: "হোম পেজের সেকশনগুলো কপি হবে। অর্ডার ফর্মে এখানে বাছাই করা পণ্য বিক্রি হবে, আর বোতামগুলো এই পেজের ফর্মে নিয়ে যাবে।",
        kind: "ধরন",
        kinds: { home: "হোম পেজ", custom: "পেজ", landing: "ল্যান্ডিং পেজ" },
        kindHints: {
            home: "ক্রেতা প্রথমে যে পেজ দেখেন। প্রতি দোকানে একটি। একটি পণ্য বিক্রি করেন? এখানেই অর্ডার ফর্ম দিন।",
            custom: "আমাদের সম্পর্কে, সাইজ গাইড, যোগাযোগ — নিজের সেকশন দিয়ে যেকোনো পেজ।",
            landing: "অর্ডার ফর্মসহ একটি পণ্য — ফেসবুক বিজ্ঞাপনের জন্য। ক্যাশ অন ডেলিভারি, SMS কোড লাগে না।",
        },
        pageTitle: "শিরোনাম",
        slug: "ঠিকানা",
        slugHint: "ছোট হাতের অক্ষর, সংখ্যা আর ড্যাশ, যেমন eid-offer",
        create: "পেজ তৈরি করুন",
        created: "পেজ তৈরি হয়েছে।",
        live: "চালু",
        draftOnly: "খসড়া",
        updated: "{{when}} পরিবর্তিত",
        open: "সম্পাদনা",
        back: "সব পেজ",
        seo: "সার্চ ইঞ্জিন",
        seoTitle: "সার্চ ফলাফলে শিরোনাম",
        seoDescription: "সার্চ ফলাফলে বিবরণ",
        sections: "সেকশন",
        sectionsHint: "ক্রেতা ওপর থেকে নিচে সেকশনগুলো দেখেন।",
        noSections: "এখনো কোনো সেকশন নেই। নিচে যোগ করুন।",
        add: "সেকশন যোগ করুন",
        up: "ওপরে নিন",
        down: "নিচে নিন",
        remove: "সরান",
        types: pageSectionTypes,
        v2: pageSectionFields,
        fields: {
            title: "শিরোনাম",
            subtitle: "উপশিরোনাম",
            buttonLabel: "বাটনের লেখা",
            buttonHref: "বাটনের লিংক (/products বা https://…)",
            image: "ছবি",
            upload: "ছবি আপলোড করুন",
            uploading: "আপলোড হচ্ছে…",
            uploadFailed: "ছবি আপলোড করা যায়নি।",
            removeImage: "ছবি সরান",
            uploadVideo: "ভিডিও আপলোড করুন",
            videoAdded: "ভিডিও যোগ হয়েছে",
            videoFailed: "ভিডিও আপলোড হয়নি (MP4, সর্বোচ্চ ১০ এমবি)।",
            removeVideo: "ভিডিও সরান",
            imageSide: "ছবি কোন পাশে",
            sides: { left: "বাঁয়ে", right: "ডানে" },
            body: "লেখা",
            category: "ক্যাটাগরি",
            allCategories: "সব ক্যাটাগরি",
            sort: "সাজানো",
            sorts: {
                newest: "নতুন আগে",
                price_asc: "দাম: কম থেকে বেশি",
                price_desc: "দাম: বেশি থেকে কম",
                name: "নাম",
            },
            limit: "কতগুলো",
            question: "প্রশ্ন",
            answer: "উত্তর",
            name: "নাম",
            quote: "তাঁরা যা বলেছেন",
            addItem: "যোগ করুন",
            endsAt: "শেষ হবে",
            product: "এই পেজে বিক্রির পণ্য",
            noProduct: "একটি পণ্য বেছে নিন।",
            allVariants: "ক্রেতা ফর্মে এর সব ভেরিয়েন্ট থেকে বেছে নেবেন: {{values}}।",
            change: "বদলান",
        },
        saveDraft: "খসড়া সংরক্ষণ",
        preview: "প্রিভিউ",
        publish: "প্রকাশ করুন",
        unpublish: "অফলাইন করুন",
        viewLive: "পেজ খুলুন",
        draftSaved: "খসড়া সংরক্ষিত হয়েছে।",
        published: "পেজটি এখন চালু।",
        unpublished: "পেজটি এখন অফলাইন।",
    },
    themes: {
        title: "দোকানের থিম",
        description: "আপনার ব্যবসার জন্য তৈরি ডিজাইন। এক ক্লিকে পেজ, ক্যাটাগরি, মেনু আর নীতিমালা সেট হয়ে যায়।",
        all: "সব",
        types: {
            fashion: "ফ্যাশন",
            beauty: "বিউটি",
            electronics: "গ্যাজেট",
            food: "খাবার",
            home: "ঘর",
            kids: "শিশু",
            accessories: "অ্যাক্সেসরিজ",
            books: "বই",
            any: "যেকোনো ব্যবসা",
        },
        premium: "প্রিমিয়াম",
        current: "ব্যবহার হচ্ছে",
        use: "এই থিম ব্যবহার করুন",
        demo: "লাইভ ডেমো",
        customise: "সাজান",
        shotDesktop: "কম্পিউটারে {{name}}",
        shotPhone: "ফোনে {{name}}",
        youGet: "যা পাবেন",
        pagesLine: "পেজ: {{pages}}",
        categoriesLine: "ক্যাটাগরি: {{categories}}",
        confirmTitle: "{{name}} থিম ব্যবহার করবেন?",
        confirmBody: "আপনার পণ্য, সেটিংস আর নিজের লেখা থাকবে। যে পেজ আর ক্যাটাগরি নেই সেগুলো যোগ হবে, আর দোকান চালু হবে।",
        replacePages: "আমার বর্তমান হোম, আমাদের সম্পর্কে ও যোগাযোগ পেজও এই থিমের লেআউটে বদলে দিন",
        sampleProducts: "দোকান যেন খালি না দেখায় সেজন্য নমুনা পণ্য যোগ করুন (পরে আর্কাইভ করতে পারবেন)",
        applying: "আপনার দোকান সাজানো হচ্ছে…",
        applied: "হয়ে গেছে! আপনার দোকানে নতুন থিম চালু।",
        openShop: "আমার দোকান খুলুন",
        rollback: "আগের চেহারা ফিরিয়ে আনুন",
        rolledBack: "আগের চেহারা ফিরে এসেছে।",
        preview: "নমুনা",
        names: {
            fashion_women: "ফ্যাশন — নারী",
            fashion_men: "ফ্যাশন — পুরুষ",
            cosmetics: "কসমেটিকস ও স্কিনকেয়ার",
            gadgets: "গ্যাজেট ও ইলেকট্রনিক্স",
            grocery: "গ্রোসারি ও অর্গানিক খাবার",
            home_kitchen: "ঘর ও রান্নাঘর",
            kids_baby: "শিশু ও বেবি",
            jewellery: "গয়না ও অ্যাক্সেসরিজ",
            home_food: "খাবার ও হোম কিচেন",
            books: "বইয়ের দোকান",
            single_product: "এক পণ্য (ফেসবুক বিজ্ঞাপন)",
            minimal: "মিনিমাল",
        },
        for: {
            fashion_women: "শাড়ি, থ্রি-পিস, কুর্তি, আবায়া, বুটিক",
            fashion_men: "পাঞ্জাবি, শার্ট, টি-শার্ট, পোলো, জিন্স",
            cosmetics: "কোরিয়ান/জাপানিজ স্কিনকেয়ার, মেকআপ, পারফিউম",
            gadgets: "ইয়ারবাড, স্মার্ট ওয়াচ, চার্জার, পাওয়ার ব্যাংক",
            grocery: "মধু, ঘি, সরিষার তেল, খেজুর, চাল",
            home_kitchen: "রান্নার সরঞ্জাম, স্টোরেজ, বেডশিট, ঘর সাজানো",
            kids_baby: "শিশুর পোশাক, খেলনা, বেবি কেয়ার",
            jewellery: "ইমিটেশন গয়না, ব্যাগ, ঘড়ি",
            home_food: "কেক, পিঠা, ফ্রোজেন ও ঘরে তৈরি খাবার",
            books: "বই, ছাপা ও ইবুক, লেখক, প্রকাশনী",
            single_product: "ফেসবুক বা টিকটক বিজ্ঞাপনে বিক্রি হওয়া একটি পণ্য",
            minimal: "যেকোনো দোকান — পরিচ্ছন্ন ও দ্রুত",
        },
    },
    tracking: {
        title: "বিজ্ঞাপন ও অ্যানালিটিক্স",
        description: "কনভারশন API-সহ ফেসবুক পিক্সেল এবং গুগল অ্যানালিটিক্স ৪। ব্রাউজার ও সার্ভার দুজনেই জানালেও একটি কেনাকাটা একবারই গোনা হয়।",
        pixelId: "ফেসবুক পিক্সেল আইডি",
        pixelHint: "শুধু সংখ্যা, Meta Events Manager থেকে।",
        capiToken: "কনভারশন API অ্যাক্সেস টোকেন",
        capiHint: "এনক্রিপ্ট করে রাখা হয়, আর কখনো দেখানো হয় না। আগেরটা রাখতে খালি রাখুন।",
        capiSaved: "একটি টোকেন সংরক্ষিত আছে।",
        removeToken: "টোকেন মুছুন",
        testCode: "টেস্ট ইভেন্ট কোড (ঐচ্ছিক)",
        testHint: "শুধু Meta-র Test events-এ সেটআপ যাচাইয়ের সময়; পরে মুছে দিন।",
        ga4Id: "গুগল অ্যানালিটিক্স ৪ মেজারমেন্ট আইডি",
        ga4Hint: "দেখতে G-XXXXXXX-এর মতো।",
        save: "সংরক্ষণ",
        saved: "বিজ্ঞাপন ও অ্যানালিটিক্স সেটিংস সংরক্ষিত হয়েছে।",
        invalidPixel: "পিক্সেল আইডি ১০ থেকে ২০ অঙ্কের হয়।",
        invalidGa4: "মেজারমেন্ট আইডি দেখতে G-XXXXXXX-এর মতো।",
    },
    accounts: {
        title: "ক্রেতা অ্যাকাউন্ট",
        description: "ক্রেতারা কীভাবে আপনার অনলাইন স্টোরে অ্যাকাউন্ট খুলবেন ও সাইন ইন করবেন।",
        signUpEmail: "ইমেইল দিয়ে অ্যাকাউন্ট খোলা",
        signUpEmailHint: "ক্রেতারা ইমেইল ঠিকানা ও পাসওয়ার্ড দিয়ে অ্যাকাউন্ট খুলতে পারবেন।",
        signUpPhone: "মোবাইল নম্বর দিয়ে অ্যাকাউন্ট খোলা",
        signUpPhoneHint: "ক্রেতারা মোবাইল নম্বর ও পাসওয়ার্ড দিয়ে অ্যাকাউন্ট খুলতে পারবেন।",
        signUpEmailCode: "অ্যাকাউন্ট খোলার সময় ইমেইল কোড চাওয়া",
        signUpEmailCodeHint: "বন্ধ: অ্যাকাউন্ট সাথে সাথে খুলবে, ইমেইল পরে নিশ্চিত করা যাবে।",
        signUpPhoneCode: "অ্যাকাউন্ট খোলার সময় SMS কোড চাওয়া",
        signUpPhoneCodeHint: "প্রতিটি কোড আপনার ক্রেডিট থেকে একটি SMS। বন্ধ: নম্বর পরে নিশ্চিত করা যাবে।",
        phoneCodeSignIn: "SMS কোড দিয়ে সাইন ইন",
        phoneCodeSignInHint: "মোবাইল অ্যাকাউন্ট পাসওয়ার্ডের বদলে কোড দিয়ে সাইন ইন করতে পারবে (SMS ক্রেডিট লাগে)।",
        google: "Google দিয়ে সাইন ইন",
        googleHint: "“Google দিয়ে চালিয়ে যান” দেখাবে। আপনার নিজের Google অ্যাকাউন্টে বানানো Google client লাগবে।",
        clientId: "Google Client ID",
        clientIdPlaceholder: "123456789012-abc.apps.googleusercontent.com",
        guideTitle: "Client ID কীভাবে পাবেন",
        guide1: "Google Cloud Console (console.cloud.google.com) খুলে আপনার দোকানের জন্য একটি project তৈরি করুন।",
        guide2: "“Google Auth Platform” → Branding: দোকানের নাম, সাপোর্ট ইমেইল ও লোগো। Audience: External, তারপর publish করুন।",
        guide3: "Clients → Create client → Application type “Web application”।",
        guide4: "“Authorized JavaScript origins”-এ নিচের প্রতিটি ঠিকানা যোগ করুন।",
        guide5: "Create করে Client ID কপি করুন, এখানে বসিয়ে সংরক্ষণ করুন।",
        origins: "আপনার দোকানের ঠিকানা",
        copy: "কপি",
        copied: "কপি হয়েছে",
        save: "সাইন-ইন সেটিংস সংরক্ষণ",
        saved: "সাইন-ইন সেটিংস সংরক্ষণ হয়েছে।",
        viewAccounts: "ক্রেতা অ্যাকাউন্ট দেখুন",
        listTitle: "অনলাইন অ্যাকাউন্ট",
        listDescription: "যে ক্রেতারা আপনার অনলাইন স্টোরে অ্যাকাউন্ট খুলেছেন।",
        search: "নাম, ইমেইল বা মোবাইল",
        empty: "এখনো কোনো ক্রেতা অ্যাকাউন্ট নেই।",
        columns: {
            name: "নাম",
            email: "ইমেইল",
            phone: "মোবাইল",
            methods: "সাইন ইন",
            status: "অবস্থা",
            lastSignIn: "শেষ সাইন ইন",
            created: "যোগ দিয়েছেন",
        },
        password: "পাসওয়ার্ড",
        googleMethod: "Google",
        verified: "যাচাই করা",
        active: "সক্রিয়",
        disabled: "বন্ধ",
        never: "কখনো না",
        disable: "বন্ধ করুন",
        enable: "চালু করুন",
        signOut: "সব জায়গা থেকে সাইন আউট",
        disabledToast: "অ্যাকাউন্টটি বন্ধ ও সাইন আউট করা হয়েছে।",
        enabledToast: "অ্যাকাউন্টটি আবার সাইন ইন করতে পারবে।",
        signedOutToast: "অ্যাকাউন্টটি সব ডিভাইস থেকে সাইন আউট হয়েছে।",
        confirmDisable: "{{name}}-এর অ্যাকাউন্ট বন্ধ করবেন? তিনি সাইন আউট হবেন এবং আবার চালু না করা পর্যন্ত সাইন ইন করতে পারবেন না।",
    },
};
//# sourceMappingURL=storefront.js.map